import { Pipe, PipeTransform } from '@angular/core';
import { Referrer } from '../../classes/referrer';

@Pipe({
    name: 'referrerNameFilter',
    pure: false
})
export class ReferrerNameFilterPipe implements PipeTransform {
    transform(referrerList: Array<Referrer>, filterValue: string): any {
        if (!referrerList || !filterValue) {
            return referrerList;
        }
        const normalizedFilterValue = filterValue.toLowerCase().trim();
        return referrerList.filter(referrer =>
            (referrer.Name || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
        );
    }
}
